import React, { FC } from "react";
import { styled, useTheme } from "@mui/material/styles";
import { IconButton, Tooltip } from "@mui/material";
type Props = {
  disabled: boolean;
  onClick: () => void;
  caption: string;
  width: number;
  height: number;
  fontSize: number;
  icon: any;
};
export const Buttons: FC<Props> = (props) => {
  const { disabled, onClick, caption, width, height, fontSize, icon } = props;
  const theme = useTheme();
  const getStyles = () => {
    let styles = {
      backgroundColor: theme.palette.foreColor.main,
      color: "#000",

      fontSize,
      height,
      // marginBottom: 16,
      width,
      boxShadow: "3px 3px 8px 1px #202226",
      transition: "all 0.3s",
      "&:hover": {
        backgroundColor: theme.palette.foreColor.light,
        color: "#37393F",
        boxShadow: "none",
        transform: "translate(3px, 3px)",
      },
    };
    return styles;
  };
  return (
    <IconButton
      component="label"
      disabled={disabled}
      onClick={onClick}
      sx={getStyles()}
    >
      <Tooltip title={caption} placement="bottom">
        {icon}
      </Tooltip>
    </IconButton>
  );
};
